/* eslint-disable */
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useEffect, useState } from "react";
import { saveTarjeta } from "../../services/TarjetaService";
import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  marca: "",
  tipo: "",
  observaciones: "",
};

const tipoTarjetaOptions = [
  {
    id: "credito",
    label: "CREDITO"
  },
  {
    id: "debito",
    label: "DEBITO"
  }
]

const nameItemText = "Tarjeta";
const itemGender = "F";
//
// ########################################################################### 
//
const TarjetaDialog = ({
  onSave,
  onClose,
  itemCrud,
  actionCrud,
  setMessage,
  setShowMessage,
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [valueACTipoTarjeta, setValueACTipoTarjeta] = useState(
    itemCrud.tipo
  );
  const [inputValueACTipoTarjeta, setInputValueACTipoTarjeta] = useState("");
  //
  // ################################################################################
  //
  useEffect(() => {
    if (actionCrud === "new") {
      setItemCrudLocal(initialState);
    } else {
      setItemCrudLocal(itemCrud);
    }
  }, []);
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleSave = () => {
    if (actionCrud === "new" || actionCrud === "update") {
      if (itemCrudLocal.marca === "") {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar la Marca de la Tarjeta",
        });
        setShowMessage(true);
        return;
      }
      if (!valueACTipoTarjeta) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar el Tipo de Tarjeta",
        });
        setShowMessage(true);
        return;
      }
    }


    save();
  };
  //
  // ########################################################################## 
  //
  const save = async () => {
    let _itemCrud = {
      marca: itemCrudLocal.marca,
      tipo: valueACTipoTarjeta ? valueACTipoTarjeta.id : "",
      observaciones: itemCrudLocal.observaciones,
    };
    if (actionCrud !== "new") {
      _itemCrud.id = itemCrudLocal.id;
    }
    setIsDoingSomething(true);
    const response = await saveTarjeta(actionCrud, _itemCrud);
    setIsDoingSomething(false);

    if (response.ok) {
      onSave();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="sm"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {actionCrud === "new"
            ? itemGender === "M"
              ? "Nuevo"
              : "Nueva"
            : actionCrud === "update"
              ? "Editando"
              : actionCrud === "enable"
                ? "Habilitando"
                : "Deshabilitando"}{" "}
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>

            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="marca"
                label="Marca de la Tarjeta"
                variant="outlined"
                size="small"
                name="marca"
                value={itemCrudLocal.marca}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"}
              />
            </Grid>

            <Grid item xs={12}>
              <Autocomplete
                sx={{ width: "100%", pb: 1 }}
                size="small"
                value={valueACTipoTarjeta}
                onChange={(event, newValue) => {
                  setValueACTipoTarjeta(newValue);
                }}
                inputValue={inputValueACTipoTarjeta}
                onInputChange={(event, newInputValue) => {
                  setInputValueACTipoTarjeta(newInputValue);
                }}
                id="tipoTarjeta"
                options={tipoTarjetaOptions}
                renderInput={(params) => <TextField {...params} label="Tipo de Tarjeta" />}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"}
                getOptionLabel={(option) => option.label || ""}
                disableClearable={true}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                inputProps={{
                  autoComplete: "off"
                }}
                id="observaciones"
                label="Observaciones"
                variant="outlined"
                name="observaciones"
                value={itemCrudLocal.observaciones}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"}
                multiline
                rows={3}
                sx={{
                  "& .MuiInputBase-root": {
                    minHeight: '80px'
                  }
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
              >
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  size="small"
                  onClick={handleSave}
                  color={actionCrud === "disable" ? "error" : "primary"}
                  startIcon={
                    actionCrud === "disable" ? (
                      <RemoveCircleOutlineIcon />
                    ) : actionCrud === "enable" ? (
                      <AddCircleOutlineIcon />
                    ) : (
                      <SaveIcon />
                    )
                  }
                >
                  {actionCrud === "disable"
                    ? "Deshabilitar"
                    : actionCrud === "enable"
                      ? "Habilitar"
                      : "Guardar"}
                </Button>

                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCloseDialog}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default TarjetaDialog;
